module.exports = __webpack_public_path__ + "static/media/providerGoldTop2D.424e876e.webp";